<div fxLayout="row" fxLayoutAlig="center center">
    <mat-icon>notification_important</mat-icon>
    <div fxFlex fxLayout="column">
        <strong>{{ "NOTIFICATION.TITLE" | translate }}</strong>
        <p>{{ msg }}</p>
        <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="end end">
            <button mat-button *ngIf="action" (click)="sbRef.dismissWithAction()">
                {{ action }}
            </button>

            <button mat-button (click)="sbRef.dismiss()">OK</button>
        </div>
    </div>
</div>
